<script setup>
import VModal from "@/Shared/VModal.vue";
import { ref } from "vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import { useForm } from "@inertiajs/vue3";
import VButton from "../../../Shared/Buttons/VButton.vue";
import VDevider from "../../../Shared/VDevider.vue";

const props = defineProps({
    type: String,
    item: Object,
    roles: Array,
    isShowApproval: {
        type: Boolean,
        default: false,
    },
});

const emits = defineEmits(["onSave", "onCancel"]);

const refModal = ref(null);
const form = useForm({
    status: null,
    remark: props.item?.document?.remark ?? "",
});

const title = "Attachment";

const cancel = () => {
    emits("onCancel");
};

const submit = (status) => {
    form.status = status;
    form.post(props.item.urlSubmit, {
        preserveScroll: true,
        forceFormData: true,
        onSuccess: () => {
            emits("onSave");
            refModal.value.closeModal();
        },
        onError: () => {
            console.log("error");
        },
    });
};
</script>
<template>
    <VModal ref="refModal" :title="title" size="modal-md" @onClose="cancel">
        <template v-slot:body>
            <div class="m-3">
                <div v-for="image in item.attachment" class="">
                    <img :src="image" alt="ktp" class="w-100" />
                </div>
            </div>
        </template>
        <template v-if="isShowApproval" v-slot:footer>
            <div class="w-100">
                <div class="mb-3">
                    <label class="form-label label-size fw-bold">
                        Remark
                    </label>
                    <textarea
                        class="form-control"
                        v-model="form.remark"
                    ></textarea>
                </div>
                <div class="text-end">
                    <VButton
                        btnStyle="btn-danger me-2"
                        :isProcessing="form.processing"
                        @onClick="submit(0)"
                    >
                        Reject
                    </VButton>
                    <VButtonSubmit
                        type="submit"
                        :isProcessing="form.processing"
                        @onCLickSubmit="submit(1)"
                    >
                        Approve
                    </VButtonSubmit>
                </div>
            </div>
        </template>
    </VModal>
</template>

<style lang="css" scoped>
.w-100 {
    width: 100%;
}
</style>
